import { render, staticRenderFns } from "./SettingsList.vue?vue&type=template&id=1a748e7e"
import script from "./SettingsList.vue?vue&type=script&lang=js"
export * from "./SettingsList.vue?vue&type=script&lang=js"
import style0 from "./SettingsList.vue?vue&type=style&index=0&id=1a748e7e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports